import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'components/dialog/Modals'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import {
  createDownload,
  fetchTableContent,
  hideDownloadModal,
  setDomainType,
  setZipped,
} from 'features/bulk/download/downloadModalSlice'
import { failWithErrorResponse, success } from 'features/toast/Toast'
import RadioButton from 'components/form/RadioButton'
import DownloadTable from 'features/bulk/download/DownloadTable'
import { fetchDownloadList } from 'features/bulk/download/downloadSlice'
import { DOMAIN_TYPE } from 'features/bulk/BulkCodes'
import CheckBox from 'components/form/CheckBox'
import HelpTooltip from 'components/tooltip/HelpTooltip'

const NAME_MAX_LENGTH = 50
const DownloadModal = () => {
  const dispatch = useDispatch()
  const {
    isShow,
    isLoading,
    disabled,
    domainType,
    ids,
    campaigns,
    bizChannels,
    zipped,
  } = useSelector(state => state.bulk.downloadModal)
  const [name, setName] = useState('')

  useEffect(() => {
    if (isShow) {
      setName('')
    }
  }, [isShow])

  useEffect(() => {
    if (isShow) {
      dispatch(fetchTableContent())
    }
  }, [dispatch, isShow, domainType])

  const handleClose = () => {
    dispatch(hideDownloadModal())
  }

  const generateFileName = () => {
    const [firstId] = ids
    const firstName =
      domainType === DOMAIN_TYPE.CAMPAIGN.name
        ? campaigns.find(c => c.id === firstId).name
        : bizChannels.find(b => b.id === firstId).name
    if (ids.length === 1) {
      return firstName
    } else {
      const maxLength = ids.length > 10 ? 42 : 43
      const slicedName =
        firstName.length > maxLength
          ? `${firstName.slice(0, maxLength)}..`
          : firstName
      return `${slicedName} 외 ${ids.length - 1}건`
    }
  }

  const handleConfirm = async () => {
    const fileName = name || generateFileName()
    const { error, payload } = await dispatch(createDownload(fileName))
    if (error) {
      failWithErrorResponse(payload, {
        messageMap: {
          404: `${
            domainType === DOMAIN_TYPE.CAMPAIGN.name ? '캠페인' : '비즈채널'
          }이 존재하지 않습니다.`,
        },
      })
    } else {
      success('요청 내용이 등록되었습니다.')
      dispatch(hideDownloadModal())
      dispatch(fetchDownloadList())
    }
  }

  const handleNameChange = event => {
    const { value } = event.target
    if (value.length <= NAME_MAX_LENGTH) {
      setName(value)
    }
  }

  return (
    <Modal className="manage_layer" on={isShow}>
      <ConfirmModal
        title="다운로드 등록하기"
        handleClose={handleClose}
        onConfirm={handleConfirm}
        confirmDisabled={ids.length === 0 || disabled}>
        <div className="item_manage">
          <strong className="tit_manage">유형 선택</strong>
          <div className="bundle_inp">
            <RadioButton.Group
              onValueChange={v => {
                dispatch(setDomainType(v))
              }}>
              <RadioButton
                checkValue={domainType}
                value="CAMPAIGN"
                label="캠페인"
                disabled={isLoading}
              />
              <RadioButton
                checkValue={domainType}
                value="CREATIVE"
                label="광고소재 관리"
                disabled={isLoading}
              />
            </RadioButton.Group>
          </div>
          <div className="box_info">
            <p className="desc_info">
              {domainType === DOMAIN_TYPE.CAMPAIGN.name ? (
                <>
                  프리미엄링크 캠페인 유형만 노출 및 다운로드 됩니다.
                  <br />
                  선택한 캠페인에 포함된 광고그룹, 키워드 등의 내용을 다운로드
                  합니다.
                  <br />
                  캠페인은 최대 20개까지 선택하여 다운로드 받을 수 있습니다.
                </>
              ) : (
                <>
                  웹사이트 비즈채널 유형만 노출 및 다운로드 됩니다.
                  <br />
                  선택한 비즈채널에 포함된 광고소재를 다운로드 합니다.
                  <br />
                  비즈채널은 최대 20개까지 선택하여 다운로드 받을 수 있습니다.
                </>
              )}
            </p>
          </div>
        </div>
        <div className="item_manage">
          <strong className="tit_manage">작업명</strong>
          <div className="box_textarea2 textarea_s">
            <textarea
              placeholder={`미작성시 ${
                domainType === DOMAIN_TYPE.CAMPAIGN.name ? '캠페인' : '웹사이트'
              }명으로 입력됩니다.`}
              className="tf_area"
              value={name}
              onChange={handleNameChange}
            />
            <span className="num_byte">
              <span className="screen_out">작성가능한 총 텍스트 수</span>
              {Math.max(NAME_MAX_LENGTH - name.length, 0)}
            </span>
          </div>
        </div>
        <div className="item_manage">
          <DownloadTable />
        </div>
        {domainType === DOMAIN_TYPE.CAMPAIGN.name && (
          <div className="item_manage">
            <CheckBox
              label="파일내 데이터 50만 행씩 나눔 생성"
              checked={zipped}
              onCheckedChange={v => dispatch(setZipped(v))}
            />
            <HelpTooltip>
              파일내 데이터를 최대 50만 행씩 나누어
              <br />
              ZIP 파일로 압축 생성합니다.
            </HelpTooltip>
          </div>
        )}
      </ConfirmModal>
    </Modal>
  )
}
export default DownloadModal
